module.exports = __webpack_public_path__ + "img/finalizados-sempedidos.8b24cdb9.png";